
export const servicesData = [
    {
      id: 1,
      title: "Product Development",
      description:
        "Vero Disruptors is at the forefront of developing innovative, reusable data products. Our product development journey is our primary mission. We partner with organizations that need comprehensive, end-to-end technical support to bring their data solutions to life.",
      details: [
        "Our Process Includes:",
        "Strategy Formulation: We begin by crafting a tailored strategy for your product development, ensuring alignment with your business objectives.",
        "Proof of Concept (POC): We then demonstrate a working POC to validate ideas and technical feasibility.",
        "Production-Level Solution: Once validated, we deploy a robust, production-ready solution designed to scale with your business needs.",
        "Maintenance & Support: We offer ongoing support and maintenance to keep your solution running optimally in production.",
        "Continuous Innovation: As your business evolves, we deploy subsequent iterations and extensions, continuously improving and expanding the solution.",
      ],
      popupContent:
        "Our primary mission is building innovative, reusable data products. From crafting a strategic roadmap to demonstrating a POC, deploying a production-level solution, and continuously iterating, we provide end-to-end technical support to power your digital transformation.",
      image:
        "https://res.cloudinary.com/dy8shu8ss/image/upload/v1741002229/DALL_E_2025-03-03_17.13.08_-_A_futuristic_and_visually_striking_digital_illustration_representing_product_development._The_image_should_feature_interconnected_data_nodes_abstract_t4vqsx.webp",
    },
    {
      id: 2,
      title: "Technical Talent & Recruitment",
      description:
        "Our expertise extends beyond product development. We understand the critical role that the right talent plays in driving project success. Our technical talent and recruitment service is designed to ensure that you have access to highly skilled resources.",
      details: [
        "What We Offer:",
        "Skilled Resource Allocation: We identify and allocate top technical talent to support your project development.",
        "Recruitment Assistance: We assist in recruiting the right talent, ensuring a strong cultural and technical fit for your organization.",
        "Project-Based Hiring: Flexible staffing solutions that meet your project needs and timelines.",
      ],
      popupContent:
        "We source and provide the right technical talent for your projects, ensuring that you have access to skilled resources. We also offer recruitment support to help you build the perfect team for your organization’s needs.",
      image:
        "https://res.cloudinary.com/dy8shu8ss/image/upload/v1742384807/download_fcrq8i.jpg",
    },
    {
      id: 3,
      title: "Training in IT",
      description:
        "As a natural extension of our talent development strategy, we provide IT training designed to keep your team at the cutting edge of technology.",
      details: [
        "Key Elements:",
        "Customized Training Programs: Tailored sessions that meet your organization’s specific skill requirements.",
        "Upskilling Initiatives: Workshops and hands-on training that help bridge current skill gaps.",
        "Internal Talent Development: Continuous learning opportunities aimed at empowering your in-house teams.",
      ],
      popupContent:
        "Using our extensive experience in developing talent, we offer targeted IT training programs to upskill your teams. Our training initiatives address internal needs and help bridge current technology skill gaps in your organization.",
      image:
        "https://res.cloudinary.com/dy8shu8ss/image/upload/v1742384343/pexels-fauxels-3184339_ctjvch.jpg",
    },
    {
      id: 4,
      title: "Internships",
      description:
        "Our internship programs are structured to give recent graduates a strong start to their careers while also addressing our internal talent development needs.",
      details: [
        "Program Highlights:",
        "Career Kickstart: Gain practical, real-world experience in a supportive environment.",
        "Mentorship: Benefit from guidance and mentoring by experienced professionals.",
        "Pathway to Employment: Many interns transition to full-time roles, strengthening our talent pipeline.",
      ],
      popupContent:
        "Designed to jumpstart careers, our internship programs offer recent graduates hands-on experience and mentorship, while also contributing to fulfilling our internal talent requirements.",
      image:
        "https://res.cloudinary.com/dy8shu8ss/image/upload/v1742384336/OIP_etujef.jpg",
    },
  ];
